// @jsx glam
import axios from 'axios'
import React, { Fragment } from 'react'
import glam from 'glam';
import Carousel, { Modal, ModalGateway } from 'react-images'
import LazyLoad, { forceCheck } from 'react-lazyload';
import './Images.css'

const dataKey = 'react_images_docs';

function getData() {
    return JSON.parse(window.sessionStorage.getItem(dataKey));
}
function setData(data) {
    // window.sessionStorage.setItem(dataKey, JSON.stringify(data));
    return data;
}

class Images extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0,
            lightboxIsOpen: false,
            images: [],
            loading: true,
            error: false,
            activeCategory: '',
            section: this.props.section,
            filteredImages: [],
            categories: []
        }
    }

    toggleLightbox = (selectedIndex) => {
        this.setState(state => ({
            lightboxIsOpen: !state.lightboxIsOpen,
            selectedIndex,
        }));
    };

    componentDidMount() {

        // using local storage to prevent API requests, don't want to exceed the limit
        const storedData = getData();

        // bail if images already available
        if (storedData) {
            const storedImages =  this.transformData(storedData);
            this.setState({
                images: storedImages,
                error: false,
                loading: false,
                filteredImages: storedImages,
                categories: this.cleanCategories(storedData)
            })
            return;
        }

        this.getProductsFeed();
    }

    getProductsFeed = () => {
        axios({
            method: 'post',
            baseURL: 'https://graphql.datocms.com/',
            timeout: 5000,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer 25344c8245894aae8d340b6374bde3`,
            },
            data: JSON.stringify({
                query:
                    `query MyQuery {
                        allCategories(orderBy: order_ASC, filter: {section: {eq: "${this.props.section}"}}) {
                            name
                            id
                            order
                            images {
                                id
                                url
                                alt
                                blurhash
                                responsiveImage {
                                    src,
                                    srcSet,
                                    sizes
                                },
                                thumbnail: responsiveImage(imgixParams: {crop: edges, w: "420", h: "420", fit: crop, auto: compress}) {
                                    srcSet
                                    src
                                    sizes
                                  }
                            }
                        }
                    }`
            })
        })
            .then((res) => {
                const resData = setData(res.data.data.allCategories);
                const resImages = this.transformData(resData);

                this.setState({
                    images: resImages,
                    error: false,
                    loading: false,
                    filteredImages: resImages,
                    categories: this.cleanCategories(resData)
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    loading: false
                })
                // TODO: proper error handling including error message
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
            });
    }

    cleanCategories = (data) => ( data.map((cat) => ( { name: cat.name, id: cat.id } )));

    changeDomain = (strUrl) => (strUrl.replace(/www\.datocms-assets\.com/g, "www.botanyco.es/imagenes"));

    transformData = (data) => {
        const transformedData = [];
        data.forEach(cat => {
            Array.isArray(cat.images) && cat.images.length > 0 && 
                transformedData.push(...cat.images.map((image) => ({
                    id: image.id,
                    category: cat.id,
                    caption: image.alt,
                    blurhash: image.blurhash,
                    source: {
                        download: this.changeDomain(image.url),
                        fullscreen: this.changeDomain(image.responsiveImage.src),
                        regular: this.changeDomain(image.responsiveImage.src) + '?dpr=1', // avoids loading src unnecessarily
                        thumbnail: this.changeDomain(image.thumbnail.src)
                        //thumbnail: image.responsiveImage.src + '?w=420&h=420&crop=edges&fit=crop&auto=compress,format',
                    },
                    srcSet: this.changeDomain(image.responsiveImage.srcSet),
                    sizes: image.responsiveImage.sizes,
                    thumbnail: {
                        srcSet: this.changeDomain(image.thumbnail.srcSet),
                        sizes: image.thumbnail.sizes,
                        src: this.changeDomain(image.thumbnail.src) + '&dpr=1' // avoids loading src image unnecessarily
                    }
                }
            )))
        });
        transformedData.sort((a,b) => (a.blurhash < b.blurhash) ? 1 : ((b.blurhash < a.blurhash) ? -1 : 0)); 
        console.log(transformedData)
        return transformedData
    }

    handleTab = (id) => {
        if (this.state.activeCategory !== id) {
            (id !== '') ?
                this.setState({
                    activeCategory: id,
                    filteredImages: this.state.images.filter((item) => item.category === id)
                }, () => (forceCheck())) :
                this.setState({
                    activeCategory: '',
                    filteredImages: this.state.images
                }, () => (forceCheck()))
        }
    };

    render() {
        const { loading } = this.props;
        const { selectedIndex, lightboxIsOpen, categories, activeCategory } = this.state;
        return (

            <Fragment>
                {!loading ? (
                    <Fragment>
                        <CatLinks items={categories} handleTab={this.handleTab} activeCategory={activeCategory} />
                        <Gallery>
                            {this.state.filteredImages.map(({ id, thumbnail, alt }, j) => (
                                <Image onClick={() => this.toggleLightbox(j)} key={id}>
                                    <LazyLoad offset="300" once>
                                        <img
                                            className='miniatura'
                                            alt={alt}
                                            src={thumbnail.src}
                                            srcSet={thumbnail.srcSet}
                                            sizes={thumbnail.sizes}
                                        />
                                    </LazyLoad>
                                </Image>
                            ))}
                        </Gallery>
                    </Fragment>
                ) : null}
                <ModalGateway>
                    {lightboxIsOpen && !loading ? (
                        <Modal onClose={this.toggleLightbox}>
                            <Carousel
                                currentIndex={selectedIndex}
                                views={this.state.filteredImages}
                                components={{View: CustomView}}
                            />
                        </Modal>
                    ) : null}
                </ModalGateway>
            </Fragment>
        );
    }
}

const Gallery = (props) => (
    <div
        className="galeria"
        {...props}
    />
);

const Image = (props) => (
    <div
        className="imagen"
        {...props}
    />
);


const CustomView = (props) => {
    const { data, formatters, getStyles, index, isFullscreen, isModal, currentIndex } = props;
    const innerProps = {
        alt: formatters.getAltText({ data, index }),
        src: data.source.regular,
        srcSet: data.srcSet,
        // sizes: data.sizes
    };

    const className = (name, state) => {
        const arr = Array.isArray(name) ? name : [name];

        // loop through state object, remove falsey values and combine with name
        if (state && typeof name === 'string') {
            for (let key in state) {
                if (state.hasOwnProperty(key) && state[key]) {
                    arr.push(`${name}--${key}`);
                }
            }
        }
        const CLASS_PREFIX = 'react-images';
        // prefix everything and return a string
        return arr.map(cn => `${CLASS_PREFIX}__${cn}`).join(' ');
    }

    return (
            <div
                css={getStyles('view', props)}
                className={className('view', { isFullscreen, isModal })}>
                {(currentIndex === index)  && <img
                    {...innerProps}
                    className={className('view-image', { isFullscreen, isModal })}
                    css={{
                        boxSizing: 'border-box',
                        height: 'auto',
                        maxHeight: '100vh',
                        maxWidth: '100vw',
                        userSelect: 'none',
                    }}
                />}
            </div>
    );
};

const CatLinks = (props) => (
    <div className="filtros">
        {[{ name: "Ver todo", id: "" }].concat(props.items).map((item) => (
            <div
                key={item.id}
                onClick={() => props.handleTab(item.id)}
                className={`tags ${item.id === props.activeCategory ? 'active' : ''}`}
            >
                {item.name}
            </div>
        ))}
    </div>
);

export default Images;